export function setupArticleLinks() {
    for (const a of Array.from(document.querySelectorAll('.navigatetoarticle'))) {
        a.addEventListener('click', (e) => {
            e.stopPropagation();
            e.preventDefault();
            window.scrollTo({
                'behavior': 'smooth',
                'top': document.getElementById('navigateToArticleSection').offsetTop
            });

        })
    }
}
